import MyCustomList from 'components/RichProfile/MyLists/MyCustomList/MyCustomList';
import { withMyCustomListProps } from 'viewModel/richProfile/myLists/myCustomList/withMyCustomListProps';

export default withMyCustomListProps(MyCustomList);
